import { useRef } from 'react';
import { useInternalLinkClickHandlers } from '@bridebook/web/app-shared/lib/landing/use-internal-link-click-handlers';
import styles from './html-page-wrapper.module.css';

interface IProps {
  html?: string;
}

const HtmlPageWrapper = ({ html }: IProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useInternalLinkClickHandlers(ref);

  return html ? (
    <div ref={ref} className={styles.wrapper} dangerouslySetInnerHTML={{ __html: html }} />
  ) : null;
};

export default HtmlPageWrapper;
